export class RequestFilter {

    RequestID?: Number;
    RequestIDs?: Number[];
    RequestDate?: Date;
    RequestDateStart?: Date;
    RequestDateEnd?: Date;
    RequestTypeIDs?: number[];
    RequestStatusIDs?: number[];
    ActionEmployeeID?: number;
    EmployeeIDs?: number[];
    SalesOfficeIDs?: number[];
    Comments?: string;
    BatchID?: number;
    Take?: number;
    AppVersion?: string;
    BrowserName?: string;
    BypassCustomerValidation?: boolean;
}

export default RequestFilter;